<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="snRule"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="规则编号">
            <el-input v-model.trim="filter.snRuleNo" placeholder="请输入规则编号" clearable/>
          </el-form-item>
          <el-form-item label="规则样式">
            <el-input v-model.trim="filter.snRuleExpression" placeholder="请输入规则样式" clearable/>
          </el-form-item>
          <el-form-item label="规则类型">
            <el-select v-model="filter.snType" placeholder="请选择规则类型" clearable>
              <el-option label="产品条码" :value="10"/>
              <el-option label="外箱条码" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="规则状态">
            <el-select v-model="filter.status" placeholder="请选择规则状态" clearable>
              <el-option label="待确认" :value="10"/>
              <el-option label="已确认" :value="20"/>
              <el-option label="已作废" :value="90"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.detailAuth" type="primary" @click="$refs.barCodeRulesEdit.open(scope.row, 1)">详情</el-button>
      </template>
    </viewTable>
    <bar-code-rules-edit ref="barCodeRulesEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import BarCodeRulesEdit from "./BarCodeRulesEdit";
  export default {
    components: { viewTable, BarCodeRulesEdit },
    data() {
      return {
        limits: {
          addAuth: this.$auth(657),
          editAuth: this.$auth(658),
          delAuth: this.$auth(660),
          detailAuth: this.$auth(659),
        },
        filter: {
          snRuleNo: "",
          snRuleExpression: "",
          snType: "",
          status: "",
        },
        columnsProperty: [
          {
            key: "snRuleNo",
            width: 100,
            align: "center",
          },
          {
            key: "snTypeName",
            width: 100,
            align: "center",
          },
          {
            key: "snRuleExpression",
            minWidth: 240,
            tooltip: true,
            ellipsis: true,
          },
          {
            key: "snRuleExpressionDesc",
            minWidth: 240,
            tooltip: true,
            ellipsis: true,
          },
          {
            key: "snLength",
            width: 90,
            align: "center",
          },
          {
            key: "statusName",
            width: 90,
            align: "center",
          },
          {
            key: "snRuleDesc",
            minWidth: 180,
          },
          {
            key: "statusName",
            width: 90,
            align: "center",
          },
          {
            key: "isDefault",
            width: 80,
            align: "center",
            render: (h, params) => {
              return h("el-tag", {
                props: {
                  type: params.row.isDefault ? "success" : "info",
                },
              }, params.row.isDefault ? "是" : "否");
            },
          },
          {
            key: "action",
            align: "center",
            width: 190,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      addEditHandle(row) {
        this.$refs.barCodeRulesEdit.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        this.$http.delete("basic", "snRule", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },
    },
  };
</script>
